export default "__VITE_ASSET__D5MuyoMd__"